// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-header {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.home-header .logo,
.home-header .logo img {
  width: 348px;
  height: 80px;
}

.home-header .home-header-nav-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-header .home-header-nav-menu .home-header-nav-menu-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  text-decoration: none;
  text-transform: uppercase;
}

.home-header .home-header-nav-menu .home-header-nav-menu-icon > img {
  width: 22px;
  height: 22px;
}

.home-header .home-header-nav-menu .home-header-nav-menu-icon:first-child {
	display: none;
}

.home-header .home-header-nav-menu .home-header-nav-menu-icon.close {
  display: none;
}

.home-header
  .home-header-nav-menu
  .home-header-nav-menu-icon
  .home-header-nav-menu-icon-title {
  margin-left: 12px;
  line-height: 21.94px;
  color: #ffffff;
  align-self: self-end;
  text-decoration: none;
}

.home-header .home-header-nav-menu .home-header-nav-menu-icon:not(:last-child) {
  margin-right: 30px;
}

.home-header .home-header-nav-menu .home-header-nav-menu-icon.menu {
  margin-right: 0;
}

.home-header
  .home-header-nav-menu
  .home-header-nav-menu-icon:hover
  .language-icon-to-be-soon-tip {
  display: flex;
  justify-content: center;
  align-items: center;
}

.language-icon-to-be-soon-tip {
  display: none;
  position: absolute;
  top: 120px;
  margin-right: 80px;
  width: 171px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.45);
  border-radius: 15px;
}

.language-icon-to-be-soon-tip span {
  font-size: 16px;
  line-height: 25px;
  color: #333333;
  font-weight: 500;
}

.language-icon-to-be-soon-tip .gear-section {
  display: flex;
  flex-basis: 20%;
}

.language-icon-to-be-soon-tip .gear-section-small-gear {
  position: absolute;
  left: 43px;
  top: 10px;
}

@media only screen and (max-width: 1200px) {
  .home-header {
    padding-top: 30px;
  }
}

@media only screen and (max-width: 768px) {
  .home-header
    .home-header-nav-menu
    .home-header-nav-menu-icon
    .home-header-nav-menu-icon-title {
    display: none;
  }

  .home-header .logo {
    width: 180px;
    height: 40px;
  }

  .home-header
    .home-header-nav-menu
    .home-header-nav-menu-icon:not(:last-child) {
    margin-right: 15px;
  }
  .home-header .home-header-nav-menu .home-header-nav-menu-icon.menu {
    margin-right: 0;
  }
}

@media only screen and (max-width: 570px) {
  .home-header .logo {
    width: 180px;
  }

  .home-header .home-header-nav-menu .home-header-nav-menu-icon svg {
    width: 20px;
    height: 20px;
  }
}

@media only screen and (max-width: 320px) {
  .home-header .home-header-nav-menu .home-header-nav-menu-icon.menu {
    display: none;
  }

  .home-header .home-header-nav-menu .home-header-nav-menu-icon.close {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;;;IAIE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".home-header {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 10px;\n}\n\n.home-header .logo,\n.home-header .logo img {\n  width: 348px;\n  height: 80px;\n}\n\n.home-header .home-header-nav-menu {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.home-header .home-header-nav-menu .home-header-nav-menu-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 16px;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n\n.home-header .home-header-nav-menu .home-header-nav-menu-icon > img {\n  width: 22px;\n  height: 22px;\n}\n\n.home-header .home-header-nav-menu .home-header-nav-menu-icon:first-child {\n\tdisplay: none;\n}\n\n.home-header .home-header-nav-menu .home-header-nav-menu-icon.close {\n  display: none;\n}\n\n.home-header\n  .home-header-nav-menu\n  .home-header-nav-menu-icon\n  .home-header-nav-menu-icon-title {\n  margin-left: 12px;\n  line-height: 21.94px;\n  color: #ffffff;\n  align-self: self-end;\n  text-decoration: none;\n}\n\n.home-header .home-header-nav-menu .home-header-nav-menu-icon:not(:last-child) {\n  margin-right: 30px;\n}\n\n.home-header .home-header-nav-menu .home-header-nav-menu-icon.menu {\n  margin-right: 0;\n}\n\n.home-header\n  .home-header-nav-menu\n  .home-header-nav-menu-icon:hover\n  .language-icon-to-be-soon-tip {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.language-icon-to-be-soon-tip {\n  display: none;\n  position: absolute;\n  top: 120px;\n  margin-right: 80px;\n  width: 171px;\n  height: 50px;\n  background-color: rgba(255, 255, 255, 0.45);\n  border-radius: 15px;\n}\n\n.language-icon-to-be-soon-tip span {\n  font-size: 16px;\n  line-height: 25px;\n  color: #333333;\n  font-weight: 500;\n}\n\n.language-icon-to-be-soon-tip .gear-section {\n  display: flex;\n  flex-basis: 20%;\n}\n\n.language-icon-to-be-soon-tip .gear-section-small-gear {\n  position: absolute;\n  left: 43px;\n  top: 10px;\n}\n\n@media only screen and (max-width: 1200px) {\n  .home-header {\n    padding-top: 30px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .home-header\n    .home-header-nav-menu\n    .home-header-nav-menu-icon\n    .home-header-nav-menu-icon-title {\n    display: none;\n  }\n\n  .home-header .logo {\n    width: 180px;\n    height: 40px;\n  }\n\n  .home-header\n    .home-header-nav-menu\n    .home-header-nav-menu-icon:not(:last-child) {\n    margin-right: 15px;\n  }\n  .home-header .home-header-nav-menu .home-header-nav-menu-icon.menu {\n    margin-right: 0;\n  }\n}\n\n@media only screen and (max-width: 570px) {\n  .home-header .logo {\n    width: 180px;\n  }\n\n  .home-header .home-header-nav-menu .home-header-nav-menu-icon svg {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .home-header .home-header-nav-menu .home-header-nav-menu-icon.menu {\n    display: none;\n  }\n\n  .home-header .home-header-nav-menu .home-header-nav-menu-icon.close {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
